import React from 'react';
import StratsTable from '@/finsight/ui/components/strats/StratsTable';

import { useStratsContext } from '@/finsight/application/Strats/StratsContext';

const StratsGroups = () => {
  const { groups, groupedStrats } = useStratsContext();
  return (
    <>
      { groups.map((group) => (
        <StratsTable
          key={ group.groupId }
          strats={ groupedStrats?.[group.groupId] }
          group={ group }
        />
      )) }
    </>
  );
};

export default StratsGroups;
